import React from 'react';
import { FormGroup, Input } from 'reactstrap';
import CheckBoxErrorText from './CheckBoxErrorText';

const GuestTypeSelector = ({ misafirTuru, girisTipiError, handleRadioOnCheck }) => (
  <div>
    <div style={{ margin: '.5rem 0 0 0', color: '#205c42' }}>
      Misafir Türü
    </div>
    <div
      style={{
        display: 'flex',
        gap: '1rem',
        margin: '0 0 .5rem 0',
        fontSize: '14px',
      }}
    >
      <FormGroup check>
        <label>
          <Input
            name='radio2'
            type='radio'
            checked={misafirTuru === 'gecici'}
            value={'gecici'}
            onChange={handleRadioOnCheck}
          />
          <span>Geçici Misafir</span>
        </label>
      </FormGroup>
      <FormGroup check>
        <label>
          <Input
            name='radio2'
            type='radio'
            checked={misafirTuru === 'kalici'}
            value={'kalici'}
            onChange={handleRadioOnCheck}
          />
          <span>Kalıcı Misafir</span>
        </label>
      </FormGroup>
      <CheckBoxErrorText textVisible={girisTipiError} />
    </div>
  </div>
);

export default GuestTypeSelector; 